<div class="meta-section">
  <div class="meta-section-header" (click)="toggleMeta()">
    <span>Meta (Facebook, Instagram)</span>
    <span class="meta-toggle-icon">{{ isMetaExpanded ? '—' : '+' }}</span>
  </div>
  <div class="meta-rows" *ngIf="isMetaExpanded">
    <div class="social-load-error" *ngIf="loadFailed()">
      Couldn't load this brand's saved Meta pages — the section is disabled and saving won't change it. Reopen the drawer to retry.
    </div>
    <div class="meta-header">
      <span class="meta-col-page">Page ID</span>
      <span class="meta-col-countries">Countries</span>
      <span class="meta-col-active">Active</span>
      <span class="meta-col-delete"></span>
    </div>
    <div class="meta-row" *ngFor="let row of metaPages.controls; let i = index; let last = last">
      <div class="meta-row-fields">
        <div class="meta-page-id">
          <app-titled-input [control]="getMetaPageIdControl(i)">
            <input
              type="text"
              [formControl]="getMetaPageIdControl(i)"
              placeholder="Enter a Meta page ID"
              (blur)="checkAndAddMetaRow(i)">
          </app-titled-input>
        </div>
        <app-select-menu
          [items]="countryOptions" [placeholder]="'Select countries'"
          [selectMode]="SelectMode.MULTI" [searchable]="true" [showSelectedIcon]="true"
          [selectAllAndClearOptions]="true"
          [iconStyle]="{ 'border-radius': '50%', 'object-fit': 'cover' }"
          [control]="getMetaCountriesControl(i)"
          [disabled]="loadFailed()"
          appendTo="body" dropDownPosition="auto"
          (onApply)="checkAndAddMetaRow(i)">
        </app-select-menu>
        <div class="meta-active" [style.visibility]="isMetaRowEmpty(i) ? 'hidden' : 'visible'">
          <app-toggle-switch
            [enabled]="!!getMetaIsActiveControl(i).value"
            (toggled)="getMetaIsActiveControl(i).setValue($event)">
          </app-toggle-switch>
        </div>
        <div class="delete-bottom">
          <app-delete-btn *ngIf="!isMetaRowEmpty(i) && metaPages.length > 1" (clicked)="removeMetaRow(i)"></app-delete-btn>
        </div>
      </div>
      <div class="meta-validation" *ngIf="getMetaValidation(i) || isManualFetch(i)">
        <ng-container *ngIf="getMetaValidation(i) as v">
          <span *ngIf="v.status === 'validating'" class="validating">Checking…</span>
          <span *ngIf="v.status === 'valid'" class="valid">
            {{ v.pageName || 'Unnamed page' }} · {{ v.activeAdsCount ?? 0 }} active ads
          </span>
          <span *ngIf="v.status === 'invalid' || v.status === 'error'" class="error">{{ v.message }}</span>
        </ng-container>
        <span *ngIf="isManualFetch(i)" class="manual-fetch-badge"
              [matTooltip]="manualFetchTooltip" matTooltipPosition="below" matTooltipClass="tooltip-with-triangle wide-tooltip">
          Manual fetch
        </span>
      </div>
      <div class="meta-row-error" *ngIf="isMetaRowCountriesMissing(i)">Select at least one country for this page.</div>
    </div>
  </div>
</div>
